export const NotificationPopUpLabels = {
    DELETE: 'Delete',
    CANCEL: 'Cancel',
};
